import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { IGetRoles, IItemForGetShortInfo } from 'types';
import { allRoles } from 'appConstants';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { useTranslation } from 'react-i18next';
import { useFetchData } from 'hooks/useFetchData';
import { getRoles } from 'backend/additionalInformation';
import { TCreateUserSelectedItem } from '../../../../../createUserState/createUserContext';
import style from './RoleSelect.module.scss';

interface IRoleSelect {
	setRole: (value: TCreateUserSelectedItem) => void;
	setFetchedRoles: (value: IItemForGetShortInfo[]) => void;
}

const RoleSelect: React.FC<IRoleSelect> = ({ setRole, setFetchedRoles }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetRoles, null>(getRoles);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	useEffect(() => {
		response && setFetchedRoles(response.data.roles);
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectRole') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		const sortedData = (response?.data.roles ? [...response.data.roles] : []).sort((a, b) => {
			return allRoles.indexOf(a.name) - allRoles.indexOf(b.name);
		});

		return (
			sortedData.map((el) => ({
				id: el.id,
				name: tForm(el.name),
				icon: (
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#userRole${el.name}`} />
					</svg>
				),
			})) || []
		);
	}, [response, tForm]);

	return (
		<FormSelect
			testId="RoleSelect"
			name="selectedRole"
			label="roleLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setRole}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(RoleSelect);
